let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3MZvl")).then(() => parcelRequire('67RNw'));